<template>
  <div v-if="payInfo">
    <div v-if="isSeparate" class="layer paymentLayer">
      <div class="inner">
        <p class="layerTitle">{{ locale.start_payment }}</p>
        <div class="btns">
          <button type="button" class="btn btnFull" @click.stop="paySubmit">{{ locale.do_payment }}</button>
        </div>
      </div>
    </div>
    <form name="payForm" id="payForm" method="post" target="_self" accept-charset="EUC-KR">
      <!--CODclearfa  /   INIpayTest -->
      <input v-if="payInfo.CharSet" type="hidden" name="CharSet" :value="payInfo.CharSet" />
      <input v-if="payInfo.GoodsName" type="hidden" name="GoodsName" :value="payInfo.GoodsName" />
      <input v-if="payInfo.Amt" type="hidden" name="Amt" :value="payInfo.Amt" />
      <input v-if="payInfo.MID" type="hidden" name="MID" :value="payInfo.MID" />
      <input v-if="payInfo.EdiDate" type="hidden" name="EdiDate" :value="payInfo.EdiDate" />
      <input v-if="payInfo.Moid" type="hidden" name="Moid" :value="payInfo.Moid" />
      <input v-if="payInfo.SignData" type="hidden" name="SignData" :value="payInfo.SignData" />
      <input v-if="payInfo.PayMethod" type="hidden" name="PayMethod" :value="payInfo.PayMethod" />
      <input v-if="payInfo.Currency" type="hidden" name="Currency" :value="payInfo.Currency" />ㄴ
      <input v-if="payInfo.ReturnUrl" type="hidden" name="ReturnUrl" :value="payInfo.ReturnUrl" />
      <input v-if="payInfo.RetryUrl" type="hidden" name="RetryUrl" :value="payInfo.RetryUrl" />
      <input v-if="payInfo.ReturnURL" type="hidden" name="ReturnURL" :value="payInfo.ReturnURL" />
      <input v-if="payInfo.RetryURL" type="hidden" name="RetryURL" :value="payInfo.RetryURL" />
      <input v-if="payInfo.ResultURL" type="hidden" name="ResultURL" :value="payInfo.ResultURL" />
      <input v-if="payInfo.closeURL" type="hidden" name="closeURL" :value="payInfo.closeURL" />
      <input v-if="payInfo.EncodeKey" type="hidden" name="EncodeKey" :value="payInfo.EncodeKey" />
      <input v-if="payInfo.GoodsCode" type="hidden" name="GoodsCode" :value="payInfo.GoodsCode" />
      <input v-if="payInfo.GoodsGroup" type="hidden" name="GoodsGroup" :value="payInfo.GoodsGroup" />
      <input v-if="payInfo.InterfaceType" type="hidden" name="InterfaceType" :value="payInfo.InterfaceType" />
      <input v-if="payInfo.OnOffCl" type="hidden" name="OnOffCl" :value="payInfo.OnOffCl" />
      <input v-if="payInfo.PaygateCode" type="hidden" name="PaygateCode" :value="payInfo.PaygateCode" />
      <input v-if="payInfo.TID" type="hidden" name="TID" :value="payInfo.TID" />
      <input v-if="payInfo.TransCl" type="hidden" name="TransCl" :value="payInfo.TransCl" />
      <input v-if="payInfo.MallIP" type="hidden" name="MallIP" :value="payInfo.MallIP" />
      <input v-if="payInfo.UserIP" type="hidden" name="UserIP" :value="payInfo.UserIP" />
      <input v-if="payInfo.NpLang" type="hidden" name="NpLang" :value="payInfo.NpLang" />
      <input type="hidden" name="OsType" :value="payInfo.OsType" />
    </form>
  </div>
</template>

<script>
export default {
  name: 'NicePayment',
  props: [
    'locale'
  ],
  computed: {
    getPayInfo: {
      get () {
        return this.$store.getters['payment/getPaymentInfo']
      },
      set (data) {
        this.payInfo = this._.cloneDeep(data)
      }
    },
    deviceOs () {
      return this.$store.getters['getDeviceOs']
    }
  },
  async mounted () {
    this.isSeparate = this.$route.name === 'separatePayment'
    if (this.getPayInfo) {
      this.payInfo = this._.cloneDeep(this.getPayInfo)
      if (this.deviceOs) {
        this.payInfo.OsType = this.deviceOs
      }
      // 알림톡 등으로부터 접근한 기본루트
      if (!this.isSeparate) {
        setTimeout(() => {
          this.paySubmit()
        }, 100)
      } else {
        // QR코드로부터 접근한 독립 결제루트
      }
    }
  },
  data () {
    return {
      payInfo: null,
      isSeparate: false
    }
  },
  methods: {
    paySubmit () {
      const actionUrl = this.payInfo.widgetUrl
      const f = document.payForm
      f.action = actionUrl
      f.submit()
      this.$emit('close')
      this.$destroy()
    },
    closePayment (e) {
      if (window.confirm(this.locale.confirm_cancel_payment)) {
        e.preventDefault()
        window.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.paymentLayer {
  .inner {
    padding: 45px 30px;
    border-radius: 8px;
  }
  .layerTitle {
    text-align: center;
  }
  .btns {
    margin-top: 30px;
    .btn {
      padding-top: 1em;
      padding-bottom: 1em;
      border-radius: 8px;
    }
  }
}
</style>
